import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { getConsent, setConsent } from '../lib/consent';
import { initAnalytics } from '../lib/analytics';

export function CookieBanner() {
  const [choice, setChoice] = useState(() => getConsent());

  // Render the banner one tick after mount so the page paint isn't blocked
  // and the banner slides in instead of flashing on top of the hero.
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    if (choice !== null) return;
    const id = window.setTimeout(() => setVisible(true), 250);
    return () => window.clearTimeout(id);
  }, [choice]);

  if (choice !== null) return null;

  const accept = () => {
    setConsent('accepted');
    setChoice('accepted');
    // Boot PostHog now that we have permission — initAnalytics() bails early
    // until consent is granted, so this is the first run.
    initAnalytics();
  };

  const decline = () => {
    setConsent('declined');
    setChoice('declined');
  };

  return (
    <div className={`cookie-banner ${visible ? 'is-visible' : ''}`} role="dialog" aria-label="Cookie consent">
      <p className="cookie-banner-text">
        SmpleCut uses a single first-party analytics cookie to understand
        which features get used. No third-party trackers, no ads, no profile
        sold on. <Link to="/privacy">Read the policy →</Link>
      </p>
      <div className="cookie-banner-actions">
        <button onClick={decline} className="btn btn-sm">Decline</button>
        <button onClick={accept} className="btn btn-sm btn-primary">Accept</button>
      </div>
    </div>
  );
}
